import { z } from 'zod'

// ─── Contractor Create Schema (POST /employees/contractors) ─────────────────

export const contractorCreateSchema = z.object({
	name: z.string().min(1, 'Name is required'),
	code: z.string().min(1, 'Code is required'),
})

export type ContractorCreateInput = z.infer<typeof contractorCreateSchema>

// ─── Contractor Update Schema (PUT /employees/contractors/:id) ──────────────

export const contractorUpdateSchema = z.object({
	name: z.string().min(1).optional(),
	code: z.string().min(1).optional(),
	isActive: z.boolean().optional(),
})

export type ContractorUpdateInput = z.infer<typeof contractorUpdateSchema>
